import { ChannelPayloadFilter, safeClone, ViewStream } from "spyne";
import { ScriptContentView } from "components/code-examples/script-content/script-content-view";
import { ScriptContentTabView } from "components/code-examples/script-content/script-content-tab-view";

export class ScriptContentHolder extends ViewStream {
  constructor(props = {}) {
    props.class = "script-content-holder";
    props.template = require("../templates/script-content-holder.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)

    const { codeBlockId } = this.props;
    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });

    return [
      [
        "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
        "onChannelCodeUpdate",
        isCodeBlockIdFilter,
      ],
    ];
  }

  onChannelCodeUpdate(e) {
    this.props.el$("button").removeClass("active");
    this.props.el$("li").removeClass("active");
    const onDispose = () => {
      if (this !== undefined) {
        this.disposeViewStream();
      }
    };

    window.setTimeout(onDispose, 100);
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  addContent() {
    const { parentVsid } = this.props;

    const addCodeItems = (d, scriptNum) => {
      const data = safeClone(d);
      data["parentVsid"] = parentVsid;
      data["scriptNum"] = scriptNum;
      //console.log("SCRIPTNUM ITER",scriptNum);
      this.appendView(
        new ScriptContentTabView({
          data,
          parentVsid,
          scriptNum,
        }),
        ".script-content-tabs-holder",
      );

      if (scriptNum > 0) {
        this.appendView(
          new ScriptContentView({
            data,
            parentVsid,
            scriptNum,
          }),
          ".script-content-views-holder",
        );
      }
    };

    this.props.data.forEach(addCodeItems);
  }

  onRendered() {
    //console.log("SCRIPT CONTENT HOLDER ",this.props);
    this.addChannel("CHANNEL_CODE_CONTAINER", true);

    this.addContent();
    this.props.el$.addAnimClass("reveal");
  }
}
